import { render } from "./TopliveCams.vue?vue&type=template&id=aceb144e"
import script from "./TopliveCams.vue?vue&type=script&lang=js"
export * from "./TopliveCams.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/landing2.elena-dating.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__